import uuid from 'uuid/v4'

/**
 * Insctance of EffectCommand
 * @class EffectCommand
 */
export default class LoadTemplateCommand {
  /**
   * Constructor
   */
  constructor(target, template) {
    this.label = 'load_template'
    this.target = target
    this.template = template
  }

  execute() {
    const canvas = this.target.canvas
    canvas.loadFromDatalessJSON(this.template.template, () => {
      this.target.grid.updateLayer(this.target)
      this.target._getCustomObjects().forEach(item => {
        item.uid = uuid()
        item.selectable = !item.locked
        item.evented = !item.locked
        item.editable = !item.locked
        if (this.template.updateTemplate) {
          item.top += this.template.updateTemplate
          item.left += this.template.updateTemplate
        }
      })
      this.target._draw()
      this.target.emit('loadedTemplate', this.target._getCustomObjects())
    })
  }

  undo() {
    const canvas = this.target.canvas
    canvas.clear()
    this.target._draw()
  }
}



// WEBPACK FOOTER //
// ./src/model/pixel/command/LoadTemplateCommand.js